'use client';

// Package Imports
import React from 'react';
import Link from 'next/link';
import styles from './error.module.scss';

const CustomError = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.content}>
          <h1><span>Uh Oh,</span> clean up on Aisle 4</h1>
          <p>An unexpected error has occured trying to load the page you were looking for.</p>
          <p>Please check the URL, try the search bar above, or visit the links below for further assistance.</p>
          <ul>
            <li><Link href="/">Home</Link></li>
            <li><Link href="/about-us/contact-us/">Contact Us</Link></li>
            <li><Link href="/shop/">Shop</Link></li>
            <li><Link href="/about-us/">About Us</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CustomError;
